// extracted by mini-css-extract-plugin
module.exports = {"container":"JackpotsContainer_container__16hPp","overlay":"JackpotsContainer_overlay__3AKJ0","scaleLogo":"JackpotsContainer_scaleLogo__2oxaJ"};